<template>
  <div id="main">
    <img
      class="banner"
      src="@/assets/image/accredif/banner_shouquan.png"
      alt=""
    />
    <div class="introduce">
      <img
        class="wow bounceInLeft"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="10"
        src="@/assets/image/accredif/bg_hezuohuoban.png"
        alt=""
      />
      <div
        class="info wow bounceInRight"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="10"
      >
        <h3>培训合作伙伴介绍</h3>
        <span>Training partner introduction</span>
        <p style="text-indent: 2em">
          依托国家广播电视总局广播电视和网络视听播音主持教育培训基地官方
          授权课程体系，面向公众市场推广全媒体运营师（职业编码：4-13-05-03）技能认证体系，
          赋能新经济形势下的数字化人才，助力事业发展。
        </p>
        <p style="text-indent: 2em">
          我们的合作伙伴基于市场痛点，针对主播、全媒体运营师开展艺术技能培训、新媒体话
          题传播培训、个人IP打造、直播带货技巧、文化礼仪等全方位培训。
        </p>
      </div>
    </div>
    <div class="wantto">
      <div
        class="info wow bounceInLeft"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="10"
      >
        <h3>成为授权培训中心</h3>
        <span>Become an authorized training center</span>
        <p style="text-indent: 2em">
          加入我们在全球不断壮大的授权培训中心团队，您的培训机构正在开设全媒体运营师培训？
          申请成为广电官方授权培训中心的一员，传授高质量培训内容，为您的学员提供“全媒体运
          营师·网络视听主播”，“茶文化网络视听主播”技能认证考试，通过者可获得广电总局官方认证
          和技能等级鉴定证书。
        </p>
        <p style="text-indent: 2em">
          同时，我们热忱欢迎具有教育资源、政府资源、艺术培训资源、MCN机构以及想在新媒体
          培训行业大展宏图的有志之士加入我们的培训中心。
        </p>
      </div>
      <div
        class="tell wow bounceInLeft"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="20"
      >
        <h4>想成为授权培训中心</h4>
        <div class="title">
          <img src="@/assets/image/accredif/tel_peixun.png" alt="" />
          <span>服务热线:</span>
        </div>
        <p>400-6520-677</p>
        <p>028-85213386</p>
      </div>
      <img
        class="wow bounceInRight"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="10"
        src="@/assets/image/accredif/peixunzhongxin.png"
        alt=""
      />
    </div>
    <div class="contact">
      <div
        class="info wow bounceInRight"
        data-wow-duration="2s"
        data-wow-delay="0"
        data-wow-offset="10"
      >
        <h3>授权合作伙伴</h3>
        <span>Authorized partner</span>
      </div>
      <div>
        <div class="left">
          <p>合作伙伴区域</p>
          <div class="location">
            <el-select
              v-model="province"
              style="width: 418px"
              @change="locationChange(province,start)"
            >
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="" id="swiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide
                class="bottom swiper-slide"
                v-for="item in citys"
                :key="item.id"
              >
                <img :src="item.logo" alt="" />
                <p class="title">
                  <span>{{ item.school }}</span>
                  <a :href="item.url">{{ item.url }}</a>
                </p>
                <p>电话:{{ item.phone }}</p>
                <div class="side"></div>
                <p>授权培训：{{ item.authorize }}</p>
                <p>授权地区：{{ item.area }}</p>
              </swiper-slide>
              <div class="bottom swiper-slide" v-if="citys.length === 0">
                暂无合作伙伴
              </div>
              <div  class="swiper-pagination" slot="pagination" style="display: flex; justify-content: center; padding: 0 0px"></div> 
            </swiper>
          </div>
        </div>
        <!-- <div id="map-box">
          <img src="@/assets/image/accredif/ditu_sqzx.png" alt="" srcset="">
        </div> -->
        <div id="echartsMap"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import echarts from "echarts";
import "echarts/map/js/china.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  metaInfo() {
    return this.metaData;
  },
  data() {
    return {
      swiperOption:{
        observer: true,//修改swiper自己或子元素时，自动初始化swiper 
        observeParents: true,//修改swiper的父元素时，自动初始化swiper 
        slidesPerView: 1,
        spaceBetween: 15,
        slidesPerGroup: 1,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          bulletClass: 'point',
          bulletActiveClass: 'active',
          clickable: true //允许分页点击跳转
        },
      },
      provinceList: [
        {
          name: "黑龙江",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            position: ["top"],
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "吉林",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "内蒙古",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "新疆",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "西藏",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "青海",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "甘肃",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "宁夏",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "陕西",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "山西",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "河北",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "辽宁",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "山东",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "河南",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "河南",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "四川",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "重庆",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "云南",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "贵州",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "广西",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "广东",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "海南",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "湖南",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "湖北",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "安徽",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "上海",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "浙江",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "江西",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "台湾",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "南海诸岛",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "福建",
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: true,
            },
          },
        },
        {
          name: "江苏",
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: false,
            },
          },
        },
        {
          name: "北京",
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: false,
            },
          },
        },
        {
          name: "天津",
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: false,
            },
          },
        },
        {
          name: "香港",
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: false,
            },
          },
        },
        {
          name: "澳门",
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              },
            },
            emphasis: {
              show: false,
            },
          },
        },
      ],
      start:"四川",
      province: "四川",
      options: [],
      citys: [],
      metaData: {
        title: "全媒体运营师培训合作授权_基地共建_MCN机构服务泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content: "全媒体运营师培训合作授权、主播培训、主播输送",
          },
          {
            name: "description",
            content:
              "泽谷传媒是国家广播电视总局教育培训基地授权的全媒体运营师合作单位。对外招募全媒体运营师招生合作单位，共建电商主播培训基地。",
          },
        ],
      },
    };
  },
  created(){
    if(this.isMobile(navigator.userAgent)){
      let url = window.location.origin.replace(/www./, "m.");
      window.location.href=url+'/page/h5/accredif.html'
    }
  },
  mounted() {
    let that = this;
    this.loadPartner("四川");
    this.locationStart();
    this.$nextTick(() => {
      let wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
      });
      wow.init();
      this.myChart = echarts.init(document.getElementById("echartsMap"));
      this.loadMap(this.provinceList);
      this.locationChange("四川", "");
      this.myChart.on("click", function (params) {
        var nowLocation = that.province;
        let location = params.name;
        that.locationChange(location, nowLocation);
      });
    });
  },
  methods: {
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    // 行政地区初始化
    locationStart() {
      this.$axios
        .get(window.location.origin + "/location.json", { dataType: "json" })
        .then((res) => {
          this.options = Object.values(res);
        });
    },
    loadPartner(param) {
      this.$axios.post("/city", { city: param }).then((res) => {
        this.citys = res ? res : [];
        this.swiper.update()
      });
    },
    loadMap(param) {
      let geo = {
        map: "china",
        // zoom :1.2,//地图大小设置
        scaleLimit: {
          min: 1,
          max: 1.2,
        },
        itemStyle: {
          normal: {
            areaColor: "#cee0f6",
            borderWidth: 1,
            borderColor: "#fff",
          },
        },
      };

      let coord = [
        { name: "成都", value: [104.065735, 29.659462] },
        { name: "武汉", value: [112.298572, 31.584355] },
        { name: "南昌", value: [115.892151, 27.676493] },
        { name: "长沙", value: [112.982279, 28.19409] },
        { name: "福州", value: [119.306239, 26.075302] },
        { name: "沈阳", value: [123.429096, 41.796767] },
      ];
      let lines_coord = [];
      coord.forEach(function (v, index) {
        index > 0 &&
          lines_coord.push({
            coords: [coord[0].value, v.value],
          });
      });
      //使用制定的配置项和数据显示图表
      this.myChart.setOption({
        //提示框组件
        tooltip: {
          show: false, //是否显示组件
          trigger: "item", //数据触发类型  item：数据图饼图触发      axis:坐标轴触发
          formatter: "{b}", //地图 {b}（区域名称）
        },
        geo: geo,
        series: [
          {
            name: "中国",
            type: "map",
            mapType: "china",
            //selectedMode: 'multiple',
            itemStyle: {
              //有2个状态  normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式
              normal: {
                label: {
                  show: true,
                  textStyle: {
                    //标签的文本样式
                    fontSize: 18,
                    color: "#000",
                  },
                },
                areaColor: "#e1ebf5",
                borderColor: "#fff", //边框颜色
                borderWidth: 0.5, //边框线宽
                areaStyle: {
                  //区域样式
                  color: "#000",
                },
              },
              emphasis: {
                borderWidth: 0.5,
                borderColor: "#fff",
                areaColor: "#00a4ff",
                label: {
                  shadowColor: "#000", //默认透明
                  shadowBlur: 10,
                  show: true,
                  textStyle: {
                    fontSize: 11,
                    color: "#000",
                  },
                },
              },
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            data: param,
            markPoint: {
              show: true,
              symbol: "circle",
              symbolSize: 10,
            },
          },
          {
            type: "effectScatter",
            zlevel: 11,
            label: {
              normal: {
                // show:true,
                fontSize: 12,
                color: "red",
                formatter: "{b}",
                offset: [-10, -10],
              },
            },
            coordinateSystem: "geo",
            symbolSize: 2,
            rippleEffect: {
              period: 4,
              brushType: "fill",
              scale: 4,
            },
            itemStyle: {
              normal: {
                color: "red",
                opacity: 1,
              },
            },
            data: coord.slice(1),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 11,
            label: {
              normal: {
                // show:true,
                fontSize: 12,
                color: "#2B3748",
                formatter: "{b}",
                offset: [-10, -10],
              },
            },
            symbolSize: 2,
            rippleEffect: {
              period: 4,
              brushType: "fill",
              scale: 4,
            },
            itemStyle: {
              normal: {
                color: "red",
                opacity: 1,
              },
            },
            data: coord.slice(0, 1),
          },
          // {
          //   type: 'lines',
          //   coordinateSystem: 'geo',
          //   zlevel: 15,
          //   effect: {
          //     show: true,
          //     period: 5,
          //     trailLength: 0,
          //     symbol: 'arrow',
          //     color: '#01AAED',
          //     symbolSize: 8,
          //   },
          //   lineStyle: {
          //     normal: {
          //       width: 1.2,
          //       opacity: 0.6,
          //       curveness: 0.2,
          //       color: '#3AA9FF'
          //     }
          //   },
          //   data: lines_coord
          // }
        ],
      });
    },
    locationChange(location, nowLocation) {
      if (nowLocation === location || location === "南海诸岛") return false;
      for (let i = 0; i < this.provinceList.length; i++) {
        if (this.provinceList[i].name === nowLocation) {
          delete this.provinceList[i].itemStyle;
        } else if (this.provinceList[i].name === location) {
          this.provinceList[i].itemStyle = {};
          this.provinceList[i].itemStyle = {
            normal: {
              areaColor: "#00a4ff",
            },
          };
        }
      }
      this.start = location
      this.province = location;
      this.loadPartner(location);
      this.loadMap(this.provinceList);
    },
  },
};
</script>
<style lang="scss">
#swiper {
  padding: 1px 1px 20px;
  overflow: hidden;
  position: relative;
  .swiper-pagination{
    box-sizing: border-box;
  }
  .swiper-container{
    padding-bottom: 20px;
  }
  .point {
    height: 4px;
    border-radius: 2px;
    width: 42px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .point.active {
    background-color: #007aff;
  }
}
</style>
<style lang="scss" scoped>
#main {
  .banner {
    width: 100%;
    display: block;
  }
  .introduce {
    display: flex;
    justify-content: center;
    padding: 75px 0 89px;
    background-image: url(../../../assets/image/accredif/huobanjieshao_yingwen.png);
    background-repeat: no-repeat;
    background-position: 90% 80%;
    > img {
      display: block;
      width: 428px;
      height: 465px;
      margin-right: 122px;
    }
    .info {
      padding-top: 85px;
      width: 590px;
      text-align: center;
    }
  }
  .introduce h3,
  .wantto h3,
  .contact h3 {
    font-size: 32px;
    color: #2b3748;
    margin: 0;
    font-weight: bold;
  }
  .introduce span,
  .wantto span {
    font-size: 14px;
    color: #7d8a9c;
  }
  .introduce p,
  .wantto p {
    color: #616975;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    margin-top: 54px;
  }
  .wantto {
    padding: 54px 0 99px;
    background: #f5faff;
    display: flex;
    justify-content: center;
    background-image: url(../../../assets/image/accredif/bg_peixunzhongxin.png);
    background-repeat: no-repeat;
    background-position: center bottom;
    position: relative;
    > img {
      display: block;
      width: 430px;
      height: 465px;
      margin-left: 232px;
    }
    > .info {
      padding-top: 80px;
      width: 533px;
      text-align: center;
    }
    .tell {
      width: 160px;
      height: 166px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px rgba(90, 154, 251, 0.7);
      border-radius: 8px;
      position: absolute;
      bottom: 56px;
      right: 34%;
      z-index: 999;
      text-align: center;
      padding: 27px 0 42px;
      box-sizing: border-box;
      z-index: 1;
      > p {
        color: #6c5ff3;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
      }
      h4 {
        font-size: 14px;
        color: #464f5b;
        font-weight: bold;
      }
    }
  }
  .contact {
    padding: 64px 0 66px;
    .info {
      text-align: center;
      margin-bottom: 75px;
      span {
        color: #7d8a9c;
        font-size: 14px;
      }
    }
    > div:last-child {
      display: flex;
      justify-content: center;
    }
    .left {
      width: 418px;
      font-size: 14px;
      color: #616975;
      margin-right: 100px;
      .location {
        position: relative;
        .option::-webkit-scrollbar {
          width: 7px;
          /*height: 4px;*/
        }
        .option::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }
        .option::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 0;
          background: rgba(0, 0, 0, 0.1);
        }
        .option {
          width: 347px;
          height: 257px;
          top: 40px;
          left: 5px;
          background: #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(55, 61, 66, 0.31);
          border-radius: 5px;
          overflow-y: auto;
          position: absolute;
          display: none;
          z-index: 99;
          li {
            padding: 5px 10px 5px 15px;
            font-size: 14px;
            font-weight: 400;
            color: #2b3748;
            cursor: pointer;
          }
          li:hover,
          li.active {
            background-color: #f0f0f0;
          }
        }
        input {
          background: none;
          outline: none;
          border: none;
        }
        .input_boxs {
          display: flex;
          border: 1px solid #dadee6;
          align-items: center;
          .xiala {
            width: 20px;
            height: 10px;
            margin-right: 20px;
          }
        }
      }
      > P:first-child {
        color: #2b3748;
        font-size: 16px;
        text-align: left;
      }
      input {
        display: block;
        width: 418px;
        height: 38px;
        background: #ffffff;
        text-indent: 14px;
      }
    }
    .bottom {
      padding: 19px 12px 36px;
      border: 1px solid #dadee6;
      width: 100%;
      box-sizing: border-box;
      text-align: left;
      img {
        display: block;
        width: 150px;
      }
    }
    .side {
      width: 100%;
      height: 1px;
      background-color: #dadee6;
      margin: 24px 0;
    }
    .title {
      display: flex;
      justify-content: space-between;
      margin-top: 1rem;
      > a {
        color: #00a4ff;
      }
    }
  }
}
#echartsMap {
  position: relative;
  overflow: hidden;
  width: 800px;
  height: 500px;
  text-align: left;
  line-height: normal;
  z-index: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
#map-box {
  position: relative;
  overflow: hidden;
  width: 800px;
  height: 500px;
  text-align: left;
  line-height: normal;
  z-index: 0;
}

</style>
